import { Company } from 'entities/Company/types';
import { User } from 'entities/User/types';
import { bootstrapImpersonation, getAuthStorage } from 'shared/helpers/impersonation';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

// must run before the store is created so persist picks the right storage
bootstrapImpersonation();

type AuthStore = {
	accessToken: string | null;
	user: User | null;
	company: Company | null;
	isPasswordExpired: boolean;
};

type AuthActions = {
	updateAuthData: (authData: Partial<AuthStore>) => void;
	reset: () => void;
	setPasswordExpired: (expired: boolean) => void;
};

const initialState: AuthStore = {
	accessToken: null,
	user: null,
	company: null,
	isPasswordExpired: false,
};

export const authStore = create<AuthStore & AuthActions>()(
	persist(
		(set) => ({
			...initialState,
			updateAuthData: (authData) => set(() => ({ ...authData })),
			reset: () => set(() => ({ ...initialState })),
			setPasswordExpired: (expired) => set(() => ({ isPasswordExpired: expired })),
		}),
		{
			name: 'authStore',
			storage: createJSONStorage(getAuthStorage),
		},
	),
);

export const useAuthStore = () => authStore((state) => state);
